import PropTypes from 'prop-types'

export default function QuillOutput({ html, style, center }) {
  const d = document.createElement('div')
  d.innerHTML = html
  // fix quill list items so the bullets have the same font size as the text
  d.querySelectorAll('li').forEach(li => {
    const innerSpan = li.querySelector('span')
    if (!innerSpan) return
    li.classList.add(...innerSpan.classList)
    innerSpan.className = ''
  })
  if (center) style = { ...style, ...{ textAlign: 'center' } }
  return <div dangerouslySetInnerHTML={{ __html: d.innerHTML }} className='ql-editor' style={style} />
}

QuillOutput.propTypes = {
  html: PropTypes.string,
  style: PropTypes.object,
  center: PropTypes.bool
}